// libs
import { styled } from '@nykaa/ui-components';

// global components
import ProductPlaceholder from 'shared/components/Product/Placeholder';

import { MEDIA_BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.section`
  content-visibility: auto;
  contain-intrinsic-size: 1900px;

  ${MEDIA_BREAKPOINTS.MOBILE} {
    width: 100%;
  }

  ${MEDIA_BREAKPOINTS.TABLET} {
    padding: ${({ theme }) => `0 ${theme.spacing.spacing60}`};
    width: 100%;
  }

  max-width: 1200px;
  margin: 0 auto;

  & > .title {
    padding: 0;
    ${MEDIA_BREAKPOINTS.MOBILE} {
      padding: ${({ theme }) => `0 ${theme.spacing.spacing60}`};
    }

    &:before {
      content: '';
      width: 100%;
      height: 1px;
      background: #000;
      margin-bottom: 1.75rem;
      display: block;

      ${MEDIA_BREAKPOINTS.TILL_TABLET_BIG} {
        margin-bottom: ${({ theme }) => theme.spacing.spacing120};
      }
    }

    &:after {
      content: '';
      height: 1.75rem;
      width: 240px;
      background: ${({ theme }) => theme.colors.shimmerBg};
      display: block;
      margin-bottom: 1.5rem;

      ${MEDIA_BREAKPOINTS.TILL_TABLET_BIG} {
        height: 20px;
        margin-bottom: ${({ theme }) => theme.spacing.spacing80};
      }
    }
  }

  & > .container {
    margin: 0 auto;
    overflow-x: auto;
    margin-bottom: ${({ theme }) => theme.spacing.spacing60};
    width: calc(100% + ${({ theme }) => theme.spacing.spacing120});
    box-sizing: border-box;

    ${MEDIA_BREAKPOINTS.TILL_TABLET_BIG} {
      width: 100%;
      padding: 0;
    }

    ${MEDIA_BREAKPOINTS.MOBILE} {
      width: 100%;
    }

    & > .content {
      display: flex;
      transform: none;
      ${MEDIA_BREAKPOINTS.MOBILE} {
        transform: translateX(${({ theme }) => theme.spacing.spacing80});
      }
    }
  }
`;

export const StyledProductPlaceholder = styled(ProductPlaceholder)`
  ${MEDIA_BREAKPOINTS.TILL_TABLET_BIG} {
    width: 40%;
    min-width: 40%;
    margin-right: ${({ theme }) => theme.spacing.spacing40};
    flex-shrink: 0;
  }
`;
